import{watchEffect as d}from"vue";function w(e,n,t){typeof window!="undefined"&&d(o=>{window.addEventListener(e,n,t),o(()=>window.removeEventListener(e,n,t))})}export{w as useWindowEvent};
